import { IFindUserInformation } from "../../../types/common.interface";
import utils from "../../../utils";
import customAxios from "../../customAxios";
import { GET_ALL_SCHOOL } from "../../routes";

type Props = {
  page?: number | string;
  limit?: number | string;
};
interface iQuery {
  value: string | undefined;
  target: "province" | "city" | "superAgent";
}

const findSchool = async (props: IFindUserInformation) => {
  var thisUrl = "";
  if (props?.page && props?.limit)
    thisUrl = `?page=${props.page}&limit=${props.limit}`;

  let body: any = {
    query: {
      userTypes: {
        $in: ["COMPANY"],
      },
    },
  };

  try {
    return (await customAxios.get(GET_ALL_SCHOOL + thisUrl, body)).data;
  } catch (error: any) {
    console.log({ GET_ALL_SCHOOL: error });
  }
};

export default findSchool;
